import { render } from "./MinipayTransactionError.vue?vue&type=template&id=93237be4&scoped=true&ts=true"
import script from "./MinipayTransactionError.vue?vue&type=script&lang=ts"
export * from "./MinipayTransactionError.vue?vue&type=script&lang=ts"

import "./MinipayTransactionError.vue?vue&type=style&index=0&id=93237be4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93237be4"],['__file',"src/components/sell/MinipayTransactionError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "93237be4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93237be4', __exports__)) {
    api.reload('93237be4', __exports__)
  }
  
  module.hot.accept("./MinipayTransactionError.vue?vue&type=template&id=93237be4&scoped=true&ts=true", () => {
    api.rerender('93237be4', render)
  })

}


export default __exports__